import request from '@/config/axios'

/** 景区核销员管理 */
export const getScenicVerifierPage = (params: any) =>
  request.get({ url: '/scenic/verifier/page', params })

export const createScenicVerifier = (data: any) =>
  request.post({ url: '/scenic/verifier/create', data })

export const updateScenicVerifier = (data: any) =>
  request.put({ url: '/scenic/verifier/update', data })

export const deleteScenicVerifier = (id: number) =>
  request.delete({ url: '/scenic/verifier/delete', params: { id } })
